import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Spin } from 'antd';

import { APP_ROUTES } from './appRoutes';
import styles from './AppRouter.module.scss';

const RouterFallback = () => (
  <div className={styles.fallback}>
    <Spin size="large" />
  </div>
);

const AppRouter = () => {
  const router = createBrowserRouter(APP_ROUTES);

  return (
    <Suspense fallback={<RouterFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default AppRouter;
